<template>
  <div class="base-height_fullscreen">
    <div class="base-flex base-width_fullscreen base-flex__between base-margin__bottom-10">
      <div>
        <el-button type="primary" :disabled="disabledCreateTask" @click="createTask('create')">{{
          $t('computingCluster.taskManagement.createTask')
        }}</el-button>
        <i
          :title="$t('computingCluster.resource.refreshList')"
          class="base-cursor__pointer el-icon-refresh base-margin__left-10"
          @click="getTaskList(true)"
        ></i>
      </div>
      <div>
        <el-button @click="clickMonitorDialog" class="base-margin__right-10" type="primary"> 监控 </el-button>
        <span class="base-margin__right-10">
          <el-button :disabled="selectedTaskIds.length === 0" @click="batchStopTask">批量终止</el-button>
          <el-button :disabled="selectedTaskIds.length === 0" @click="batchDeleteTask">批量删除</el-button>
        </span>
        <el-select
          v-model="filterTaskStatus"
          clearable
          multiple
          :placeholder="$t('computingCluster.taskManagement.selectStatus')"
          class="base-width__240"
          @change="getTaskList(true)"
        >
          <el-option
            v-for="item in taskStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>
    <el-table v-loading="tableLoading" :data="tableData" @selection-change="batchSelectionTaskId" class="task_table">
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        :label="$t('computingCluster.taskManagement.taskId')"
        prop="id"
        width="88"
        align="center"
      ></el-table-column>
      <el-table-column
        :label="$t('computingCluster.taskManagement.assignmentName')"
        prop="name"
        align="center"
      ></el-table-column>
      <el-table-column label="节点数量" prop="nodeCount" width="100" align="center"></el-table-column>
      <el-table-column label="单节点CPU数目" prop="cpu" width="150" align="center"></el-table-column>
      <el-table-column label="优先级" prop="priority" width="150" align="center"></el-table-column>
      <el-table-column label="作业状态" prop="status" width="130">
        <template slot-scope="scope">
          <div class="base-width_fullscreen base-flex__cross-center">
            <div class="base-flex__cross-center base-width_fullscreen">
              <img class="taskStatusCls" :src="getTaskStatusImage(scope.row.status)" />
              <span class="base-margin__left-4">
                {{ fileTaskStatusList(scope.row.status) }}
              </span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('computingCluster.taskManagement.queueName')"
        prop="partition"
        align="center"
      ></el-table-column>
      <el-table-column label="运行时长" prop="runTime" align="center">
        <template slot-scope="scope">
          {{ scope.row.runTime ? scope.row.runTime : '-' }}
        </template>
      </el-table-column>
      <el-table-column
        width="150"
        :label="$t('computingCluster.taskManagement.createTime')"
        prop="createTime"
        align="center"
      ></el-table-column>
      <el-table-column
        :label="$t('computingCluster.taskManagement.updateTime')"
        width="150"
        prop="updateTime"
        align="center"
      ></el-table-column>
      <!-- 操作列，使用国际化标签 -->
      <el-table-column :label="$t('computingCluster.taskManagement.operation')" width="300">
        <template slot-scope="scope">
          <el-button
            :disabled="
              scope.row.status === taskManageStatusList.ClusterTaskStatusSuccess &&
              scope.row.status === taskManageStatusList.ClusterTaskStatusFailed &&
              scope.row.status === taskManageStatusList.ClusterTaskStatusRunning
            "
            size="small"
            type="text"
            @click="describeClusterTasksResult(scope.row)"
          >
            <!--{{ $t('computingCluster.taskManagement.startTask') }}-->
            详情
          </el-button>
          <!--<el-button-->
          <!--  :disabled="scope.row.status === 1 && scope.row.status === 2 && scope.row.status === 3"-->
          <!--  size="small"-->
          <!--  type="text"-->
          <!--  @click="executionResults(scope.row)"-->
          <!--&gt;-->
          <!--  &lt;!&ndash;{{ $t('computingCluster.taskManagement.startTask') }}&ndash;&gt;-->
          <!--  运行结果-->
          <!--</el-button>-->
          <el-button
            size="small"
            :disabled="
              scope.row.status !== taskManageStatusList.ClusterTaskStatusRunning &&
              scope.row.status !== taskManageStatusList.ClusterTaskStatusPending
            "
            type="text"
            @click="cancelClusterTask([scope.row.id])"
          >
            {{ $t('computingCluster.taskManagement.cancelClusterTask') }}
          </el-button>
          <el-button
            size="small"
            type="text"
            @click="createTask('recreate', scope.row)"
            :disabled="
              scope.row.status === taskManageStatusList.ClusterTaskStatusPending ||
              scope.row.status === taskManageStatusList.ClusterTaskStatusData
            "
          >
            重新提交
          </el-button>
          <el-button
            size="small"
            :disabled="
              scope.row.status === taskManageStatusList.ClusterTaskStatusRunning ||
              scope.row.status === taskManageStatusList.ClusterTaskStatusPending
            "
            type="text"
            @click="deleteTask([scope.row.id])"
          >
            {{ $t('common.delete') }}
          </el-button>
          <el-button
            size="small"
            v-if="isOwner"
            :disabled="scope.row.status !== taskManageStatusList.ClusterTaskStatusPending"
            type="text"
            @click="setTaskPriority(scope.row)"
          >
            设置优先级
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页器 -->
    <el-pagination
      :page-size="10"
      :page-sizes="[10, 20, 50, 100]"
      :total="tableDataTotal"
      align="right"
      class="pagination"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="onCurrentChange"
    >
    </el-pagination>

    <!-- 任务详情对话框 -->
    <el-drawer
      :title="'任务详情 - ' + taskForm.name"
      :close-on-click-modal="false"
      :visible.sync="taskDrawerVisible"
      direction="rtl"
      size="90%"
      top="5vh"
    >
      <div class="task-details" v-loading="taskDetailsLoading">
        <!-- 基本信息 -->
        <el-card class="detail-card">
          <template #header>
            <span>基本信息</span>
          </template>
          <el-descriptions :column="3" border>
            <el-descriptions-item label="任务ID">{{ taskForm.jobId }}</el-descriptions-item>
            <el-descriptions-item label="任务名称">{{ taskForm.name }}</el-descriptions-item>
            <el-descriptions-item label="状态">
              <el-tag>
                {{ fileTaskStatusList(taskForm.status) }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="分区">{{ taskForm.partition }}</el-descriptions-item>
            <el-descriptions-item label="节点数">{{ taskForm.nodeCount }}</el-descriptions-item>
            <el-descriptions-item label="CPU数">{{ taskForm.cpu }}</el-descriptions-item>
            <!--<el-descriptions-item label="内存">{{ taskForm.memory }}</el-descriptions-item>-->
            <!--<el-descriptions-item label="时间限制">{{ taskForm.timeLimit }}</el-descriptions-item>-->
            <el-descriptions-item label="工作目录">{{ taskForm.workDir }}</el-descriptions-item>
            <el-descriptions-item label="输出日志">{{ taskForm.outFile }}</el-descriptions-item>
            <el-descriptions-item label="错误日志">{{ taskForm.errFile }}</el-descriptions-item>
            <el-descriptions-item label="运行时间">{{ taskForm.runTime }}</el-descriptions-item>
          </el-descriptions>
        </el-card>

        <!-- 脚本内容 -->
        <el-card class="detail-card" v-if="taskForm.command">
          <template #header>
            <span>提交脚本</span>
          </template>
          <el-input v-model="taskDetails.script" type="textarea" :rows="10" readonly class="script-textarea" />
        </el-card>

        <!-- 输出日志 -->
        <el-card class="detail-card">
          <template #header>
            <span>输出日志</span>
          </template>
          <el-input v-model="taskDetails.outFile" type="textarea" :rows="8" readonly class="log-textarea" />
        </el-card>

        <!-- 错误日志 -->
        <el-card class="detail-card">
          <template #header>
            <span>错误日志</span>
          </template>
          <el-input v-model="taskDetails.errFile" type="textarea" :rows="6" readonly class="error-textarea" />
        </el-card>

        <!-- 相关文件 -->
        <el-card class="detail-card">
          <template #header>
            <p class="base-flex__between">
              <span>相关文件</span>
              <el-button
                type="text"
                :disabled="!cosFileDownReady"
                @click="downloadFile(batchDownLoadFilesList, 'detail')"
              >
                批量下载
              </el-button>
            </p>
          </template>
          <el-table
            ref="taskCosFileList"
            :data="systemFileList"
            @selection-change="handleCheckBatchDownLoad"
            style="width: 100%"
            max-height="400"
          >
            <!-- 多选框 -->
            <el-table-column :selectable="selectable" type="selection" width="55"></el-table-column>
            <el-table-column prop="name" label="文件名" />
            <!--<el-table-column prop="path" label="路径" />-->
            <el-table-column prop="size" label="大小" width="320">
              <template slot-scope="scope">{{ sizeFilter(scope.row.size, 'downLoad') }}</template>
            </el-table-column>
            <el-table-column prop="process" label="上传进度" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.process !== undefined">{{ scope.row.process }}%</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template #default="{ row }">
                <el-button
                  type="text"
                  size="small"
                  :disabled="row.process !== 100"
                  @click="downloadFile([row], 'detail')"
                >
                  下载
                </el-button>
                <!--<el-button type="text" size="small" @click="downloadFile([row])">-->
                <!--  重新加载-->
                <!--</el-button>-->
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>
    </el-drawer>

    <!--HPC任务提交系统 drawer-->
    <!--:before-close="handleSubmitTaskClose"-->
    <el-drawer
      title="HPC作业提交系统"
      :visible.sync="submitTaskVisible"
      :close-on-click-modal="false"
      size="90%"
      direction="rtl"
      top="5vh"
    >
      <div class="task-submit" v-loading="doneTaskManageLoading">
        <div class="base-flex task-submit_border">
          <div style="width: 50%" class="taskConfig-card">
            <el-tabs v-model="submitTaskActiveName" @tab-click="handleTabsClick" class="el-menu-demo" mode="horizontal">
              <el-tab-pane label="可视化配置" name="taskConfig">
                <!-- 左侧：任务配置表单 -->
                <el-card>
                  <!--<template #header>-->
                  <!--  <span>任务配置</span>-->
                  <!--</template>-->
                  <div class="base-width_fullscreen setDividerCls">
                    <el-form
                      ref="taskFormRef"
                      :model="taskForm"
                      :rules="taskRules"
                      label-width="130px"
                      label-position="top"
                    >
                      <!-- 基本信息 -->
                      <el-divider content-position="left">基本信息</el-divider>
                      <div class="base-flex">
                        <el-form-item label="任务名称" label-width="80px" prop="name">
                          <el-input v-model="taskForm.name" placeholder="请输入任务名称" clearable />
                        </el-form-item>
                        <el-form-item label="软件选择" class="base-margin__left-20" label-width="80px" prop="software">
                          <el-select
                            v-model="taskForm.software"
                            placeholder="请选择运行软件"
                            @change="handleSoftwareChange"
                          >
                            <el-option
                              v-for="(item, index) in softwareList"
                              :key="index"
                              :label="item.label"
                              :value="item.value"
                            />
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="软件版本"
                          class="base-margin__left-20"
                          v-if="watchTaskConfig.softwareVersion"
                          label-width="80px"
                          prop="softwareVersion"
                        >
                          <el-select
                            v-model="taskForm.softwareVersion"
                            placeholder="请选择软件版本"
                            @change="handleSoftwareVersionChange"
                          >
                            <el-option
                              v-for="(item, index) in softwareVersionList"
                              :key="index"
                              :label="item.label"
                              :value="item.value"
                            />
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="提交方式"
                          class="base-margin__left-20"
                          label-width="80px"
                          v-if="taskForm.software === 'LS-Dyna'"
                          prop="submissionMethod"
                        >
                          <el-select
                            v-model="taskForm.submissionMethod"
                            placeholder="请选择提交方式"
                            @change="handleSubmissionMethodChange"
                          >
                            <el-option
                              v-for="(item, index) in submissionMethodList"
                              :key="index"
                              :label="item.label"
                              :value="item.value"
                            />
                          </el-select>
                        </el-form-item>
                      </div>

                      <!-- 资源配置 -->
                      <el-divider content-position="left">资源配置</el-divider>
                      <div class="base-flex">
                        <el-form-item label="分区" label-width="60px" prop="partition">
                          <div>
                            <el-select v-model="taskForm.partition" placeholder="请选择集群分区">
                              <el-option
                                v-for="item in queueList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.name"
                              />
                            </el-select>
                          </div>
                        </el-form-item>
                        <el-form-item label="节点数" class="base-margin__left-20" label-width="80px" prop="nodeCount">
                          <el-input-number
                            v-model="taskForm.nodeCount"
                            :min="1"
                            :max="100"
                            class="base-width_fullscreen"
                          />
                        </el-form-item>

                        <el-form-item label="单节点CPU核数" class="base-margin__left-20" label-width="130px" prop="cpu">
                          <el-input-number v-model="taskForm.cpu" :min="1" class="base-width_fullscreen" />
                        </el-form-item>
                      </div>
                    </el-form>
                  </div>
                  <div class="base-font-size__16px">
                    <p v-for="(item, index) in coreStateUsageList" :key="index" :style="`color: ${item.color}`">
                      {{ item.PartitionName }} - {{ item.defaultName }}
                    </p>
                  </div>
                </el-card>
              </el-tab-pane>
              <el-tab-pane label="脚本配置" name="scriptEditing">
                <el-card class="script-card">
                  <div class="script-editor">
                    <el-input
                      v-model="taskForm.script"
                      type="textarea"
                      :rows="17"
                      placeholder="请输入Slurm提交脚本..."
                      class="script-textarea"
                    />
                  </div>
                </el-card>
              </el-tab-pane>
            </el-tabs>
            <el-card v-loading="fileLoading" class="workFileBox setDividerCls">
              <el-divider content-position="left" style="width: 50%">文件配置</el-divider>
              <div>
                <div class="base-flex__cross-center base-width_fullscreen">
                  <span class="base-width__100">工作目录</span>
                  <div class="base-flex__cross-center base-width_fullscreen base-margin__bottom-5">
                    <span class="pathInputCls">{{ fileUploadPath }}/</span>
                    <el-autocomplete
                      class="base-width_fullscreen"
                      @input="handleWorkDirChange"
                      v-model="taskForm.workDir"
                      placeholder="请输入工作目录路径"
                      value-key="name"
                      :fetch-suggestions="querySearchDirList"
                    >
                      <el-button slot="append" type="primary" @click="openWorkDirDialog"> 选择工作目录 </el-button>
                    </el-autocomplete>
                  </div>
                </div>
                <span v-if="taskForm.submissionMethod === 'interactive'">
                  <div class="base-flex__cross-center" v-if="watchTaskConfig.mainFile">
                    <span class="base-width__100">{{ watchTaskConfig.mainFileTitle }}</span>
                    <div
                      class="base-position__relative base-width_fullscreen"
                      @drop="handleMasterFileDrop"
                      @dragover="handleDragOver"
                    >
                      <el-upload
                        class="upload-demo main_file_upload"
                        drag
                        :file-list="masterFile"
                        :auto-upload="false"
                        :show-file-list="false"
                        action=""
                        multiple
                        :on-change="handleMasterFileChange"
                      >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                      </el-upload>
                      <div class="base-position__absolute uploadFileList">
                        <p
                          v-for="(item, index) in masterFile"
                          :key="index"
                          class="base-flex__between base-flex__cross-center"
                        >
                          <i class="el-icon-tickets"></i>
                          <span class="uploadFileListNameClass">
                            {{ item.name }}
                          </span>
                          <span v-if="item.name !== ''">
                            <el-button type="text" @click="removeMasterFile(index)">{{
                              $t('common.remove')
                            }}</el-button>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="base-flex__cross-center">
                    <span class="base-width__100">{{ watchTaskConfig.commonFileTitle }}</span>
                    <div
                      class="base-position__relative base-width_fullscreen"
                      @drop="handleCommonFileDrop"
                      @dragover="handleDragOver"
                    >
                      <el-upload
                        class="upload-demo common_file_upload"
                        :auto-upload="false"
                        :file-list="uploadFileList"
                        :on-change="handleCommonFileChange"
                        :show-file-list="false"
                        drag
                        action=""
                        multiple
                      >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                      </el-upload>
                      <div class="base-position__absolute uploadFileList">
                        <p
                          v-for="(item, index) in uploadFileList"
                          :key="index"
                          class="base-flex__between base-flex__cross-center"
                        >
                          <i class="el-icon-tickets"></i>
                          <span class="uploadFileListNameClass">
                            {{ item.name }}
                          </span>
                          <span v-if="item.name !== ''">
                            <el-button type="text" @click="removeUploadFile(index)">{{
                              $t('common.remove')
                            }}</el-button>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </span>
                <span v-else>
                  <div class="base-flex__cross-center base-width_fullscreen">
                    <span class="base-width__100">主文件</span>
                    <div class="base-flex__cross-center base-width_fullscreen base-margin__bottom-5">
                      <el-input v-model="taskForm.batchMainFileName" placeholder="请指定输入文件名称"></el-input>
                    </div>
                  </div>
                </span>
              </div>
            </el-card>
          </div>
          <el-divider class="dividerVertical" direction="vertical"></el-divider>
          <div style="width: 50%">
            <el-divider class="dividerVertical" direction="vertical" />
            <div v-loading="fileDirectoryLoading">
              <div class="base-flex__cross-center base-flex__between base-font-size__14px">
                <span>
                  <span>我的文件： </span>
                  <span class="base-width__240">{{ pathInput }}</span>
                  <el-button
                    :disabled="backPageBol"
                    class="base-margin__left-24 base-margin__right-10 dialogTrueCls"
                    type="text"
                    @click="backPage"
                    >{{ $t('computingCluster.taskManagement.returnPreviousPage') }}
                  </el-button>
                  <el-button
                    class="base-margin__left-10 base-margin__right-10 dialogTrueCls"
                    type="text"
                    @click="returnRoot"
                    >{{ $t('computingCluster.taskManagement.returnRootDirectory') }}
                  </el-button>
                  <el-button
                    class="refresh dialogTrueCls base-text-align__right"
                    icon="el-icon-refresh"
                    :title="$t('common.refresh')"
                    type="text"
                    @click="getDirectoryList"
                  ></el-button>
                </span>
                <el-dropdown class="base-margin__right-32">
                  <span class="base-color__light_blue base-cursor__pointer">
                    文件操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="file">
                      <p @click="createClusterFile('file')">
                        <span> 创建文件 </span>
                      </p>
                    </el-dropdown-item>
                    <el-dropdown-item command="dir">
                      <p @click="createClusterFile('dir')">
                        <span> 创建文件夹 </span>
                      </p>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-upload
                        :auto-upload="false"
                        :file-list="uploadServerFileList"
                        :on-change="handleServerFileChange"
                        :show-file-list="false"
                        action=""
                        multiple
                      >
                        <span> 上传文件 </span>
                      </el-upload>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-upload
                        ref="uploadServerFileRef"
                        :auto-upload="false"
                        :file-list="uploadServerFileList"
                        :on-change="handleServerFileChange"
                        :show-file-list="false"
                        action=""
                        multiple
                        webkitdirectory
                      >
                        <span> 上传文件夹 </span>
                      </el-upload>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <p @click="downloadServerFile">
                        <span> 下载COS文件 </span>
                      </p>
                    </el-dropdown-item>
                    <el-dropdown-item :disabled="selectionServerFileList.length === 0">
                      <p @click="deleteServerFile(selectionServerFileList)">
                        <span> 批量删除 </span>
                      </p>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="table">
                <el-table
                  :data="systemFileList"
                  ref="serverFileTable"
                  height="calc(100vh - 250px)"
                  max-height="calc(100vh - 250px)"
                  @selection-change="selectionServerFile"
                >
                  <el-table-column type="selection" width="55"> </el-table-column>
                  <!-- 文件名 -->
                  <el-table-column :label="$t('computingCluster.taskManagement.fileName')">
                    <template slot-scope="scope">
                      <div v-if="scope.row.is_dir">
                        <i class="el-icon-folder-opened base-margin__right-5"></i>
                        <el-button
                          class="dialogTrueCls"
                          style="padding: 0"
                          type="text"
                          @click="openFolder(scope.row.name)"
                          >{{ scope.row.name }}
                        </el-button>
                      </div>

                      <div v-else>
                        <i class="el-icon-tickets base-margin__right-5"></i>
                        <span
                          draggable="true"
                          @dragstart="handleDragStart(scope.row)"
                          @click="dragUpload(scope.row)"
                          style="cursor: pointer; user-select: none"
                          >{{ scope.row.name }}</span
                        >
                      </div>
                    </template>
                  </el-table-column>
                  <!-- 文件大小 -->
                  <el-table-column :label="$t('computingCluster.taskManagement.fileSize')">
                    <template slot-scope="scope">{{ sizeFilter(scope.row.size, 'showFile') }}</template>
                  </el-table-column>
                  <!-- 更新时间 -->
                  <!--<el-table-column label="更新时间">-->
                  <!--  <template slot-scope="scope">{{ processTime(scope.row.mod_time) }}</template>-->
                  <!--</el-table-column>-->
                  <!-- 上传进度 -->
                  <!--<el-table-column label="上传进度" width="120">-->
                  <!--  <template slot-scope="scope">-->
                  <!--    <span v-if="fileUploadProgress[scope.row.name] !== undefined">-->
                  <!--      {{ fileUploadProgress[scope.row.name] }}%-->
                  <!--    </span>-->
                  <!--    <span v-else>-</span>-->
                  <!--  </template>-->
                  <!--</el-table-column>-->
                  <el-table-column :label="$t('computingCluster.taskManagement.updateTime')" width="160">
                    <template slot-scope="scope">
                      {{ processTime(scope.row.mod_time) }}
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('common.actions')" width="200">
                    <template slot-scope="scope">
                      <!--<span v-if="!scope.row.is_dir">-->
                      <!--  <el-button-->
                      <!--    type="text"-->
                      <!--    v-if="taskForm.software !== 'vasp'"-->
                      <!--    @click="cosFileSelect(scope.row, 'master')"-->
                      <!--    >主文件上传</el-button-->
                      <!--  >-->
                      <!--  <el-button type="text" @click="cosFileSelect(scope.row, 'common')">{{-->
                      <!--    taskForm.software === 'vasp' ? '输入文件上传' : '普通文件上传'-->
                      <!--  }}</el-button>-->
                      <span>
                        <el-button
                          type="text"
                          v-if="!scope.row.is_dir"
                          @click="previewServerFile(`${pathInput}/${scope.row.name}`)"
                        >
                          {{ $t('customCluster.baseInfo.preview') }}
                        </el-button>
                        <!--<el-button-->
                        <!--  type="text"-->
                        <!--  @click="downloadServerFile(scope.row)"-->
                        <!--&gt;-->
                        <!--  {{ $t('common.download') }}-->
                        <!--</el-button>-->
                        <el-button type="text" @click="deleteServerFile([`${pathInput}/${scope.row.name}`])">
                          {{ $t('common.delete') }}
                        </el-button>
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
        <div class="base-margin__right-32 base-text-align__center">
          <el-button
            type="primary"
            size="large"
            :disabled="fileLoading"
            class="base-margin__top-20 base-margin__bottom-20"
            @click="submitTask"
          >
            提交任务
          </el-button>
        </div>
      </div>
      <el-dialog
        title="预览文件"
        :visible.sync="previewDialogVisible"
        :z-index="1000"
        :close-on-click-modal="false"
        width="600px"
      >
        <el-input v-model="previewContent" type="textarea" :rows="20" readonly class="error-textarea" />
      </el-dialog>
    </el-drawer>

    <!-- 工作目录选择弹窗 -->
    <el-dialog
      title="选择工作目录"
      :visible.sync="workDirDialogVisible"
      width="60%"
      :before-close="
        () => {
          workDirDialogVisible = false;
        }
      "
    >
      <div class="work-dir-dialog" v-loading="workDirDialogLoading">
        <!-- 路径导航 -->
        <div class="path-navigation">
          <el-button
            type="text"
            @click="returnWorkDirDialogRoot"
            :disabled="workDirDialogPath === `${homePath}/${linuxName}`"
          >
            <i class="el-icon-s-home"></i> 返回根目录
          </el-button>
          <el-button
            type="text"
            @click="backWorkDirDialogPage"
            :disabled="workDirDialogPath === '/' || workDirDialogPath === `${homePath}/${linuxName}`"
          >
            <i class="el-icon-back"></i> 返回上级
          </el-button>
          <span class="current-path">{{ workDirDialogPath }}</span>
        </div>

        <!-- 文件列表 -->
        <div class="file-list-container">
          <el-table
            :data="workDirDialogList"
            height="400"
            @row-click="(row) => openWorkDirDialogFolder(row.name)"
            style="width: 100%"
          >
            <el-table-column prop="name" label="文件夹名称">
              <template slot-scope="scope">
                <div class="folder-item">
                  <i class="el-icon-folder-opened"></i>
                  <span class="folder-name">{{ scope.row.name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="size" label="大小" width="120">
              <template slot-scope="scope">
                {{ scope.row.size ? sizeFilter(scope.row.size) : '-' }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  @click.stop="selectWorkDirDialogFolder(scope.row.name)"
                  :disabled="workDirDialogLoading"
                >
                  选择
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 操作按钮 -->
        <div class="dialog-actions">
          <el-button @click="createWorkDirDialogFolder" type="primary">
            <i class="el-icon-folder-add"></i> 新建文件夹
          </el-button>
          <el-button @click="workDirDialogVisible = false">取消</el-button>
          <el-button
            v-if="workDirDialogList.length === 0"
            type="primary"
            @click.stop="selectWorkDirDialogFolder('')"
            @click="workDirDialogVisible = false"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 下载文件弹窗 -->
    <DownloadFile ref="downloadFileRef"></DownloadFile>
  </div>
</template>

<script>
import { postRequest } from '@/common/libs/request';
import { Base64 } from 'js-base64';
import dayjs from 'dayjs';
import { getMimeType, processTime } from '@/common/utils/utils';
import { mapGetters, mapState } from 'vuex';
import { cosGetObject } from '@/common/utils/cosApi';
import { Message } from 'element-ui';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import { taskManageStatusList } from '@/common/constants';
import DownloadFile from '@/views/remoteDestop/components/downloadFile';

export default {
  name: 'taskManagement',
  components: {
    DownloadFile,
  },
  data() {
    return {
      tableLoading: false,
      tableData: [],
      pageIndex: 1,
      pageLimit: 10,
      tableDataTotal: 0,
      taskDrawerVisible: false,
      taskDetailsLoading: false,
      taskStatusList: [],
      filterTaskStatus: [],
      doneTaskManageLoading: false,
      taskForm: {
        name: `task_${dayjs().format('YYYYMMDDHHmmss')}`,
        nodeCount: 1,
        cpu: 1,
        workDir: 'workDir',
        partition: 'cpuq',
        files: [],
        command: '',
        script: 'script',
        software: 'vasp',
        softwareVersion: 'CPU 5.4.4',
        submissionMethod: 'interactive',
        batchMainFileName: '',
      },

      uploadFileList: [],
      masterFile: [],
      currentDraggedFile: null,
      linuxName: '',
      homePath: '',
      taskInstanceId: '',
      taskVncUser: 'common',
      systemFileVisible: false,
      processTime,
      systemFileList: [],
      backPageBol: true,
      pathInput: '',
      fileLoading: false,
      workDirDialogLoading: false,
      taskDetailsDialogVisible: false,
      taskDetails: {
        outFile: '',
        errFile: '',
        script: '',
      },
      stopRecursion: false,
      disabledCreateTask: true,
      submitTaskVisible: false,
      submitTaskActiveName: 'taskConfig',
      taskRules: {
        name: [
          { required: true, message: '请输入任务名称', trigger: 'blur' },
          { min: 1, max: 50, message: '任务名称长度应在1-50个字符', trigger: 'blur' },
        ],
        // partition: [{ required: true, message: '请选择集群分区', trigger: 'change' }],
        workDir: [{ required: true, message: '请输入工作目录', trigger: 'blur' }],
        nodeCount: [{ required: true, message: '请输入节点数', trigger: 'blur' }],
        cpu: [{ required: true, message: '请输入CPU核数', trigger: 'blur' }],
        // software: [{ required: true, message: '请选择软件', trigger: 'change' }],
      },
      queueList: [],
      fileUploadPath: '',
      softwareList: [
        { label: '无', value: '' },
        { label: 'vasp', value: 'vasp' },
        { label: 'LS-Dyna', value: 'LS-Dyna' },
        { label: 'Starccm+', value: 'StarCCM+' },
      ],
      getDirectoryType: 'taskInfo',
      selectedTaskIds: [],
      defaultWorkDir: '',
      isOwner: 0,
      batchDownLoadFilesList: [], // 批量下载文件列表
      cosFileDownReady: false, // 是否准备好cos文件下载
      coreStateUsageList: [], // 集群核心使用情况
      dirList: [], // 目录列表
      isSearchingDirList: false, // 是否正在搜索目录列表
      workDirDialogVisible: false, // 工作目录选择弹窗显示状态
      workDirDialogPath: '', // 弹窗当前路径
      workDirDialogList: [], // 弹窗文件列表
      taskListTimer: null, // 任务列表定时器
      selectionServerFileList: [], // 选择服务器文件
      previewContent: '', // 预览内容
      previewDialogVisible: false, // 预览对话框是否可见
      uploadServerFileList: [], // 上传服务器文件列表
      fileDirectoryLoading: false, // 文件目录加载中

      softwareVersionList: [
        { label: 'CPU 5.4.4', value: 'CPU 5.4.4' },
        { label: 'GPU 6.1.0', value: 'GPU 6.1.0' },
        { label: 'GPU 6.4.2', value: 'GPU 6.4.2' },
      ],
      vaspVersionList: [
        { label: 'CPU 5.4.4', value: 'CPU 5.4.4' },
        { label: 'GPU 6.1.0', value: 'GPU 6.1.0' },
        { label: 'GPU 6.4.2', value: 'GPU 6.4.2' },
      ],
      lsdynaVersionList: [
        {
          label: 'ls-dyna_mpp_s_r11_0_0_x64_centos65_ifort160_avx2_intelmpi-413',
          value: 'ls-dyna_mpp_s_r11_0_0_x64_centos65_ifort160_avx2_intelmpi-413',
        },
        {
          label: 'ls-dyna_mpp_d_r11_0_0_x64_centos65_ifort160_avx2_intelmpi-413',
          value: 'ls-dyna_mpp_d_r11_0_0_x64_centos65_ifort160_avx2_intelmpi-413',
        },
      ],
      starccmVersionList: [{ label: '15.06.007-R8', value: 'starccm+_15.06.007-R8' }],
      watchTaskConfig: {
        softwareVersion: true,
        mainFile: false,
        mainFileTitle: '主文件',
        commonFileTitle: '输入文件',
      },
      taskManageStatusList,
      submissionMethodList: [
        { label: '单任务提交', value: 'interactive' },
        { label: '批量提交', value: 'batch' },
      ],
      batchSubmitTaskFileList: [],
      imagePlatform: JSON.parse(sessionStorage.getItem('currentProject')).masterNode.imagePlatform,
    };
  },

  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    'app.currentProject'() {
      this.pageLimit = 10;
      this.pageIndex = 1;
      this.tableDataTotal = 0;
      this.getTaskList(true);
      this.getProjectInfo();
      const currentProject = this.getCurrentProject();
      this.isOwner = currentProject.isOwner;
    },
    taskDrawerVisible(newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        // 抽屉从打开变为关闭时，停止递归
        this.stopRecursion = true;
        console.log('抽屉已关闭，设置停止递归标志');
      } else if (newVal === true) {
        // 抽屉打开时，重置停止递归标志
        this.stopRecursion = false;
        console.log('抽屉已打开，重置递归标志');
      }
    },
    'taskForm.software'(val) {
      if (val === '') {
        this.watchTaskConfig = {
          softwareVersion: false,
          mainFile: true,
          mainFileTitle: '主文件',
          commonFileTitle: '普通文件',
        };
      }
      if (val === 'vasp') {
        this.watchTaskConfig = {
          softwareVersion: true,
          mainFile: false,
          mainFileTitle: '主文件',
          commonFileTitle: '输入文件',
        };
      }
      if (val === 'LS-Dyna') {
        this.watchTaskConfig = {
          softwareVersion: true,
          mainFile: true,
          mainFileTitle: '主文件',
          commonFileTitle: '普通文件',
        };
      }
      if (val === 'StarCCM+') {
        this.watchTaskConfig = {
          softwareVersion: true,
          mainFile: true,
          mainFileTitle: '模型文件（.Sim）',
          commonFileTitle: 'JAVA文件',
        };
      }
    },
  },

  created() {
    this.taskStatusList = [
      { label: this.$t('computingCluster.taskManagement.taskStatus.runningSuccess'), value: 1 },
      { label: this.$t('computingCluster.taskManagement.taskStatus.runningFailed'), value: 2 },
      { label: this.$t('computingCluster.taskManagement.taskStatus.running'), value: 3 },
      { label: this.$t('computingCluster.taskManagement.taskStatus.readyStart'), value: 4 },
      { label: this.$t('computingCluster.taskManagement.taskStatus.cancel'), value: 5 },
      { label: this.$t('computingCluster.taskManagement.taskStatus.nodeFailed'), value: 6 },
      { label: this.$t('computingCluster.taskManagement.taskStatus.dataPreparation'), value: 7 },
    ];
  },
  async mounted() {
    this.getTaskList(true);
    // 启动定时器，每30秒获取一次任务列表
    this.taskListTimer = setInterval(() => {
      this.getTaskList(false);
    }, 30000);

    await this.getProjectInfo();
    const currentProject = this.getCurrentProject();
    this.isOwner = currentProject.isOwner;

    // 初始化时查询当前工作目录的子文件夹
    if (this.taskForm.workDir && this.taskForm.workDir !== 'workDir') {
      this.querySubDirectories(this.taskForm.workDir);
    }
  },

  beforeDestroy() {
    // 组件销毁前清理定时器
    if (this.taskListTimer) {
      clearInterval(this.taskListTimer);
      this.taskListTimer = null;
    }
  },

  methods: {
    /**
     * 任务提交方式
     */
    handleSubmissionMethodChange(val) {
      this.taskForm.submissionMethod = val;
      // 清空上传文件列表
      this.uploadFileList = [];
      this.masterFile = [];
    },

    /**
     * 处理软件版本变更
     */
    handleSoftwareChange(val) {
      this.taskForm.software = val;
      this.masterFile = [];
      this.uploadFileList = [];
      if (val === '') {
        this.softwareVersionList = [];
        this.taskForm.softwareVersion = '';
      }
      if (val === 'vasp') {
        this.softwareVersionList = this.vaspVersionList;
        this.taskForm.softwareVersion = this.vaspVersionList[0].value;
      }
      if (val === 'LS-Dyna') {
        this.softwareVersionList = this.lsdynaVersionList;
        this.taskForm.softwareVersion = this.lsdynaVersionList[0].value;
        this.taskForm.submissionMethod = 'interactive';
      }
      if (val === 'StarCCM+') {
        this.softwareVersionList = this.starccmVersionList;
        this.taskForm.softwareVersion = this.starccmVersionList[0].value;
      }
      if (val === 'StarCCM+') {
        this.softwareVersionList = this.starccmVersionList;
        this.taskForm.softwareVersion = this.starccmVersionList[0].value;
      }
    },

    handleSoftwareVersionChange(val) {
      this.taskForm.softwareVersion = val;
    },

    /**
     * 统一处理文件和文件夹上传
     * @param {Object} file 当前文件对象
     * @param {Array} fileList 当前文件列表
     */
    async handleServerFileChange(file, fileList) {
      const uploadPromises = [];
      // 处理文件夹上传
      if (file.raw.webkitRelativePath) {
        const folderName = file.raw.webkitRelativePath.split('/')[0];
        fileList.map((item) => {
          if (item.raw.webkitRelativePath) {
            // 只处理文件夹内的文件，不上传文件夹本身
            if (item.raw.webkitRelativePath.split('/').length > 1) {
              const fileName = `${folderName}/${item.raw.webkitRelativePath
                .split('/')
                .slice(1)
                .join('/')
                .replace(/\\s+/g, '_')
                .replace(' ', '_')}`;
              const cosPath = `${this.pathInput}/${fileName}`.replace(this.fileUploadPath, '').substr(1);
              uploadPromises.push({
                ...item,
                name: fileName,
                uploadPath: cosPath,
                syncParams: {
                  instanceFilePath: `${this.pathInput}/${fileName}`,
                  cosFilePath: `${this.pathInput}/${fileName}`.replace(this.homePath, ''),
                  instanceId: this.taskInstanceId,
                },
                raw: new File([item.raw], cosPath, {
                  type: item.raw.type,
                  lastModified: item.raw.lastModified,
                  webkitRelativePath: item.raw.webkitRelativePath,
                }),
              });
            }
          }
        });
        // 文件夹遍历完成后，统一提交进度信息
        this.$store.commit('app/setUploadProgressList', uploadPromises);
      } else {
        // 处理单个文件上传
        const fileName = `${file.name}`.replace(/\\s+/g, '_').replace(' ', '_');
        const cosPath = `${this.pathInput}/${fileName}`.replace(this.fileUploadPath, '').substr(1);
        uploadPromises.push({
          ...file,
          size: file.raw.size,
          name: fileName,
          syncParams: {
            instanceFilePath: `${this.pathInput}/${fileName}`,
            cosFilePath: `${this.pathInput}/${fileName}`.replace(this.homePath, ''),
            instanceId: this.taskInstanceId,
          },
          raw: new File([file.raw], cosPath),
        });

        // 单个文件直接提交进度信息
        this.$store.commit('app/setUploadProgressList', uploadPromises);
      }
    },

    /**
     * 获取项目全部队列列表
     * **/
    getQueueList() {
      // 获取项目全部队列列表
      postRequest('/api/eda/common/cluster/describeTaskQueueList', {}).then((res) => {
        if (res.total > 0) {
          this.queueList = res.list.filter(item => item.name !== 'local' && item.name !== 'login');
          this.getClusterCoreUsage();
        } else {
          this.taskForm.partition = '';
        }
      });
    },

    /**
     * 创建任务
     */
    createTask(type, info) {
      this.openDirectoryDialog();
      this.getQueueList();
      this.getDirectoryType = 'createTask';
      if (type === 'recreate') {
        this.taskForm = {
          ...JSON.parse(JSON.stringify(info)),
          script: 'script',
        };
        this.taskForm.workDir = info.workDir.replace(this.pathInput, '');
        if (this.taskForm.workDir[0] === '/') {
          this.taskForm.workDir = this.taskForm.workDir.substring(1);
        }
        this.taskForm.name = `recreate_${this.taskForm.name}`;
        this.defaultWorkDir = this.taskForm.workDir;
        if (info.mainFile === '') {
          this.masterFile = [];
        } else {
          this.masterFile = info.mainFile.split(',').map(name => ({ name })) || [];
        }
        if (info.files === '') {
          this.uploadFileList = [];
        } else {
          this.uploadFileList = info.files.split(',').map(name => ({ name })) || [];
        }
      } else {
        this.defaultWorkDir = '';
        this.masterFile = [];
        this.uploadFileList = [];
        this.taskForm = {
          name: `task_${dayjs().format('YYYYMMDDHHmmss')}`,
          nodeCount: 1,
          cpu: 1,
          workDir: '',
          partition: 'cpuq',
          files: [],
          command: '',
          software: 'vasp',
          script: 'script',
          softwareVersion: 'CPU 5.4.4',
          submissionMethod: 'interactive',
          batchMainFileName: '',
        };
        // 如果队列列表为空，则不显示队列选择
        // if (this.queueList.length === 0) {
        //   console.log(this.queueList, 'sssssss');
        //   this.taskForm.partition = '';
        // }
        this.handleWorkDirChange('');
      }
      if (this.taskForm.command !== '') {
        this.handleTabsClick({ name: 'scriptEditing' });
        this.taskForm.script = Base64.decode(JSON.parse(JSON.stringify(info.command)));
      } else {
        this.handleTabsClick({ name: 'taskConfig' });
      }

      this.submitTaskVisible = true;
      this.$nextTick(() => {
        this.$refs.uploadServerFileRef.$children[0].$refs.input.webkitdirectory = true;
        this.$refs.uploadServerFileRef.$children[0].$refs.input.directory = true;
      });
    },

    /**
     * 获取项目信息
     */
    async getProjectInfo() {
      const data = await this.$store.dispatch('app/getProjectInfo', {
        instanceId: 'ins-mmq04q5m',
      });

      this.disabledCreateTask = data.clusterCount === 0 || this.imagePlatform === 'windows';

      this.taskInstanceId = data.instanceId;
      this.linuxName = data.linuxName;
      this.homePath = data.settings.homePath;
      this.pathInput = `${this.homePath}/${this.linuxName}`;
      this.fileUploadPath = `${this.homePath}/${this.linuxName}`;
    },

    /**
     * 查询任务详情
     */
    describeClusterTasksResult(info) {
      this.taskForm = JSON.parse(JSON.stringify(info));
      this.taskDetails = {
        outFile: '',
        errFile: '',
        script: '',
      };
      this.getDirectoryType = 'taskInfo';
      this.cosFileDownReady = false;

      this.pathInput = info.workDir;
      this.getTaskInfoDirectoryList();

      // 重置递归停止标志
      this.stopRecursion = false;

      // 显示抽屉并开启loading
      this.taskDrawerVisible = true;
      this.taskDetailsLoading = true;

      if (info.command !== '') {
        this.taskDetails.script = Base64.decode(info.command);
      }

      this.executionResults(info);
    },

    /**
     * 查询集群的核心使用情况
     */
    async getClusterCoreUsage() {
      if (this.queueList.length === 0) return;
      const params = {
        partitionList: this.queueList.map(item => item.name) || [],
      };
      await postRequest('/api/eda/common/cluster/describeSlurmPartitionInfo ', params)
        .then((res) => {
          const list = res.partitionInfoList.map((item) => {
            item.defaultName = `总计${item.NodeTotalCount || 0}个节点-已分配${
              item.NodeAllocatedCount || 0
            }个节点-闲置${item.NodeIdleCount || 0}个节点-异常${item.NodeOtherCount || 0}个节点 / 总计${
              item.CoreStateUsage.TotalCpus || 0
            }核-已分配${item.CoreStateUsage.AllocCpus || 0}核-闲置${item.CoreStateUsage.IdleCpus || 0}核-异常${
              item.CoreStateUsage.OtherCpus || 0
            }核`;
            if (Number(item.NodeIdleCount) !== 0) {
              item.color = '#67C23A';
            } else {
              item.color = '#F56C6C';
            }
            return item;
          }) || [];
          this.coreStateUsageList = list || [];
        })
        .catch(() => {
          this.coreStateUsageList = [];
        });
    },

    /**
     * 运行结果
     */
    executionResults(info) {
      const params = {
        errFile: info.errFile,
        outFile: info.outFile,
      };
      const errFilePromise = postRequest('/api/eda/common/cluster/describeFileContent', {
        filePath: `${info.workDir}/${params.errFile}`,
      }).then((res) => {
        if (res.content === '') {
          this.taskDetails.errFile = this.$t('customCluster.manage.noData');
        } else {
          this.taskDetails.errFile = res.content;
        }
      });
      const outFilePromise = postRequest('/api/eda/common/cluster/describeFileContent', {
        filePath: `${info.workDir}/${params.outFile}`,
      }).then((res) => {
        if (res.content === '') {
          this.taskDetails.outFile = this.$t('customCluster.manage.noData');
        } else {
          this.taskDetails.outFile = res.content;
        }
      });

      Promise.all([errFilePromise, outFilePromise]).then(() => {
        this.taskDetailsLoading = false;
      });
    },

    /**
     * 关闭弹窗之前的提示
     */
    // handleSubmitTaskClose() {
    //   if (this.fileLoading) {
    //     this.$confirm('文件正在上传中，退出将取消上传并丢失进度。确定要退出吗？', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning',
    //     }).then(() => {
    //       this.submitTaskVisible = false;
    //     });
    //   } else {
    //     this.submitTaskVisible = false;
    //   }
    // },

    /**
     * 修改工作目录（节流处理）
     */
    handleWorkDirChange(val) {
      // 如果正在搜索目录列表，则不执行目录变更逻辑
      if (this.isSearchingDirList) {
        return;
      }

      // 节流处理：500ms内只执行一次
      const now = Date.now();
      if (now - this.lastWorkDirChangeTime < 500) {
        // 清除之前的定时器
        if (this.workDirThrottleTimer) {
          clearTimeout(this.workDirThrottleTimer);
        }
        // 设置新的定时器
        this.workDirThrottleTimer = setTimeout(() => {
          this.executeWorkDirChange(val);
        }, 500);
        return;
      }

      this.lastWorkDirChangeTime = now;
      this.executeWorkDirChange(val);
    },

    /**
     * 打开工作目录选择弹窗
     */
    openWorkDirDialog() {
      this.workDirDialogVisible = true;
      // 参考pathInput的路径设置方式
      this.workDirDialogPath = `${this.homePath}/${this.linuxName}`;
      this.getWorkDirDialogList();
    },

    /**
     * 执行工作目录变更逻辑
     */
    executeWorkDirChange(val) {
      if (this.masterFile.length > 0 || this.uploadFileList.length > 0) {
        this.$confirm('当前目录已上传文件，修改工作目录将清空文件，是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.defaultWorkDir = val;
            this.masterFile = [];
            this.uploadFileList = [];
            // 查询新目录下的子文件夹
            this.querySubDirectories(val);
          })
          .catch(() => {
            this.taskForm.workDir = this.defaultWorkDir;
            this.$message({
              type: 'info',
              message: '已取消操作',
            });
          });
      } else {
        // 直接查询新目录下的子文件夹
        this.querySubDirectories(val);
      }
    },

    /**
     * 查询指定目录下的子文件夹
     */
    querySubDirectories(workDir) {
      if (!this.taskInstanceId) return;

      const fullPath = `${this.pathInput}/${workDir}`;
      const params = {
        instanceId: this.taskInstanceId,
        dirPath: fullPath,
      };

      postRequest('/api/eda/common/project/getDirectoryList', params)
        .then((res) => {
          const subDirectories = res?.list?.filter(item => item.name.charAt(0) !== '.' && item.is_dir) || [];

          // 更新目录列表，包含当前目录的子文件夹
          this.dirList = subDirectories.map(item => (workDir === ''
            ? { ...item, name: item.name }
            : { ...item, name: `${workDir}/${item.name}`.replace(/\/\//g, '/') }));
        })
        .catch((error) => {
          console.error('查询子目录失败:', error);
          // 查询失败时保持原有目录列表
        })
        .finally(() => {
          // 确保loading状态被正确关闭
        });
    },

    /**
     * 本地master文件上传
     */
    handleMasterFileChange(file) {
      if (this.taskForm.workDir === '') return this.$message.error('请先选择工作目录路径！');
      if (this.masterFile.length > 0) {
        this.$confirm('主文件已存在，是否需要替换主文件？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          // 处理覆盖文件上传
          const fileName = `${this.taskForm.workDir}/${file.name}`.replace(/\s+/g, '_').replace(' ', '_');
          const newFile = {
            name: fileName,
            size: file.raw.size,
            raw: new File([file.raw], fileName),
            syncParams: {
              instanceFilePath: `${this.fileUploadPath}/${fileName}`,
              cosFilePath: `${this.fileUploadPath}/${fileName}`.replace(this.homePath, ''),
              instanceId: this.taskInstanceId,
            },
          };

          this.$store.commit('app/setUploadProgressList', [newFile]);
        });
      } else {
        // 处理单个文件上传
        const fileName = `${this.taskForm.workDir}/${file.name}`.replace(/\s+/g, '_').replace(' ', '_');
        const newFile = {
          name: fileName,
          size: file.raw.size,
          raw: new File([file.raw], fileName),
          syncParams: {
            instanceFilePath: `${this.fileUploadPath}/${fileName}`,
            cosFilePath: `${this.fileUploadPath}/${fileName}`.replace(this.homePath, ''),
            instanceId: this.taskInstanceId,
          },
        };
        this.$store.commit('app/setUploadProgressList', [newFile]);
      }
      this.masterFile = [{ name: file.name }];
    },
    /**
     * 本地文件上传（支持多文件）
     */
    handleCommonFileChange(file, fileList) {
      if (this.taskForm.workDir === '') return this.$message.error('请先选择工作目录路径！');

      // 批量处理所有上传的文件
      const uploadPromises = [];
      const newUploadFiles = [];

      fileList.forEach((uploadFile) => {
        // 检查文件是否已存在
        const existingFileIndex = this.uploadFileList.findIndex(item => item.name === uploadFile.name);

        if (existingFileIndex !== -1) {
          // 文件已存在，需要替换
          const fileName = `${this.taskForm.workDir}/${uploadFile.name}`.replace(/\s+/g, '_').replace(' ', '_');
          const newFile = {
            name: fileName,
            size: uploadFile?.raw?.size || 0,
            raw: new File([uploadFile.raw], fileName),
            syncParams: {
              instanceFilePath: `${this.fileUploadPath}/${fileName}`,
              cosFilePath: `${this.fileUploadPath}/${fileName}`.replace(this.homePath, ''),
              instanceId: this.taskInstanceId,
            },
          };
          uploadPromises.push(newFile);

          // 更新上传文件列表
          this.uploadFileList.splice(existingFileIndex, 1, {
            name: uploadFile.name,
          });
        } else {
          // 新文件
          const fileName = `${this.taskForm.workDir}/${uploadFile.name}`.replace(/\s+/g, '_').replace(' ', '_');
          const newFile = {
            name: fileName,
            size: uploadFile.raw.size,
            raw: new File([uploadFile.raw], fileName),
            syncParams: {
              instanceFilePath: `${this.fileUploadPath}/${fileName}`,
              cosFilePath: `${this.fileUploadPath}/${fileName}`.replace(this.homePath, ''),
              instanceId: this.taskInstanceId,
            },
          };
          uploadPromises.push(newFile);

          // 添加到上传文件列表
          newUploadFiles.push({
            name: uploadFile.name,
          });
        }
      });

      // 批量提交上传进度
      if (uploadPromises.length > 0) {
        this.$store.commit('app/setUploadProgressList', uploadPromises);
      }

      // 批量添加到上传文件列表
      if (newUploadFiles.length > 0) {
        this.uploadFileList.push(...newUploadFiles);
      }
    },

    /**
     * 移除已上传的文件
     */
    removeUploadFile(index) {
      this.uploadFileList.splice(index, 1);
    },

    /**
     * 移除已上传的主文件
     */
    removeMasterFile(index) {
      const fileName = this.masterFile[index]?.name;
      if (fileName) {
        // 清理进度信息
        this.$delete(this.fileUploadProgress, fileName);
      }
      this.masterFile.splice(index, 1);
    },

    /**
     * 选择服务器已上传文件
     */
    cosFileSelect(item, type) {
      if (type === 'master') {
        if (this.masterFile.length > 0) {
          // 检查文件是否已存在
          this.$confirm('主文件已存在，是否需要替换主文件？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              this.masterFile = [{ name: item.name }];
              this.copyFileToDist({
                name: item.name,
              });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消替换',
              });
            });
        } else {
          this.masterFile = [{ name: item.name }];
          this.copyFileToDist({
            name: item.name,
          });
        }
      } else {
        // 检查文件是否已存在
        const existingFileIndex = this.uploadFileList.findIndex(file => file.name === item.name);
        if (existingFileIndex !== -1) {
          this.$confirm('文件已存在，是否需要替换文件？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              // 替换已存在的文件
              this.uploadFileList.splice(existingFileIndex, 1, {
                name: item.name,
              });
              this.copyFileToDist({
                name: item.name,
              });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消替换',
              });
            });
        } else {
          this.uploadFileList.push({
            name: item.name,
          });
          this.copyFileToDist({
            name: item.name,
          });
        }
      }
    },

    /**
     * 删除服务器文件
     */
    deleteServerFile(files) {
      this.$confirm('确定删除文件/文件夹？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.fileDirectoryLoading = true;
          postRequest('/api/eda/common/cluster/removeClusterFile', {
            instanceId: this.taskInstanceId,
            files,
          })
            .then(() => {
              this.$message({
                type: 'success',
                message: '删除成功',
              });
              this.getDirectoryList();
            })
            .catch(() => {
              this.fileDirectoryLoading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },

    /**
     * 预览服务器文件
     */
    previewServerFile(file) {
      this.fileDirectoryLoading = true;
      postRequest('/api/eda/common/cluster/describeFileContent', {
        filePath: file,
      })
        .then((res) => {
          this.fileDirectoryLoading = false;
          if (res.content === '') {
            this.previewContent = this.$t('customCluster.manage.noData');
          } else {
            this.previewContent = res.content;
          }
          this.previewDialogVisible = true;
        })
        .catch(() => {
          this.fileDirectoryLoading = false;
        });
    },

    /**
     * 下载服务器文件
     */
    downloadServerFile() {
      this.$refs.downloadFileRef.openDownload();
    },

    /**
     * 复制文件到指定目录
     */
    copyFileToDist(file) {
      const params = {
        srcFilePath: `${this.pathInput}/${file.name}`,
        workDir: `${this.fileUploadPath}/${this.taskForm.workDir}`,
        instanceId: this.taskInstanceId,
        isSyncToCos: 1,
      };
      postRequest('/api/eda/common/cluster/copyFileToDist', params).then(() => {
        this.getDirectoryList();
      });
    },

    /**
     * 同步COS数据到实例的指定目录
     */
    syncCosToDist(params) {
      params.scene = 2;
      params.instanceFilePath = params.instanceFilePath.replace(/\/\//g, '/');

      // 在开始同步前将文件添加到同步进度列表
      // const fileName = params.cosFilePath.split('/').pop();
      postRequest('/api/eda/common/cluster/syncCosToDist', params)
        .then(() => {
          console.log('文件同步请求成功，开始轮询进度');
          // 开始轮询查询同步进度
          this.pollUploadSyncProgress(params.cosFilePath, params.instanceFilePath, 2);
        })
        .catch((error) => {
          console.error('文件同步请求失败:', error);
        });
    },

    /**
     * 轮询查询上传文件的同步进度
     */
    pollUploadSyncProgress(cosFilePath, instanceFilePath, scene, maxRetries = 100, currentRetry = 0) {
      if (currentRetry >= maxRetries) {
        this.$message.warning('文件同步查询达到最大重试次数，请手动刷新目录查看同步结果');
        return;
      }

      // 构建查询参数
      const fileName = cosFilePath.split('/').pop();
      const queryParams = {
        files: [
          {
            cosPath: cosFilePath,
            filePath: instanceFilePath,
            name: fileName,
          },
        ],
        scene,
      };

      console.log('查询文件同步进度，参数:', queryParams);
      postRequest('/api/eda/common/cluster/describeUploadFiles', queryParams)
        .then((res) => {
          console.log('文件同步进度查询结果:', res);
          if (res.list && res.list.length > 0) {
            const fileInfo = res.list[0];
            const progress = fileInfo.process || 0;

            // 检查是否同步完成
            if (progress === 100) {
              // 延迟移除已完成文件，给用户看到完成状态
              setTimeout(() => {
                // 同步完成后刷新目录列表
                this.getDirectoryList();
              }, 1000);
              return;
            }
          }

          // 继续轮询
          setTimeout(() => {
            this.pollUploadSyncProgress(cosFilePath, instanceFilePath, scene, maxRetries, currentRetry + 1);
          }, 1000); // 1秒后再次查询
        })
        .catch((error) => {
          console.error('查询同步进度失败:', error);
          // 出错时也继续轮询，但增加重试间隔
          setTimeout(() => {
            this.pollUploadSyncProgress(cosFilePath, instanceFilePath, scene, maxRetries, currentRetry + 1);
          }, 5000);
        });
    },

    /**
     * 删除任务
     */
    deleteTask(taskId) {
      this.$confirm('确定删除任务？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          postRequest('/api/eda/common/cluster/deleteSlurmTask', { taskId }).then(() => {
            Message.success(this.$t('computingCluster.clusterEnv.deleteSuccess'));
            this.getTaskList(true);
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },

    /**
     * 创建文件、文件夹
     */
    // fileDropdown(item) {
    //   if (item === 'batchDelete') {
    //     this.deleteServerFile();
    //   } else {
    //     this.createClusterFile(item);
    //   }
    // },

    /**
     * 创建文件、文件夹
     */
    createClusterFile(val) {
      this.$prompt(`请输入${val === 'dir' ? '目录' : '文件'}名称`, `创建${val === 'dir' ? '目录' : '文件'}`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputErrorMessage: '名称不能为空',
      })
        .then(({ value }) => {
          this.fileDirectoryLoading = true;
          postRequest('/api/eda/common/cluster/createClusterFile', {
            instanceId: this.taskInstanceId,
            filePath: `${this.pathInput}/${value}`,
            fileType: val,
          }).then(() => {
            Message.success(`创建${value}${val === 'dir' ? '目录' : '文件'}成功`);
            this.getDirectoryList();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: `取消创建${val === 'dir' ? '目录' : '文件'}`,
          });
        });
    },

    /**
     * 设置任务优先级
     */
    setTaskPriority(val) {
      this.$prompt(`请输入优先级, 当前优先级为${val.priority || 0}`, '设置优先级', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputErrorMessage: '优先级不正确',
      })
        .then(({ value }) => {
          postRequest('/api/eda/common/cluster/setSlurmPriority', {
            taskIds: [val.id],
            priority: Number(value),
          }).then(() => {
            Message.success('设置优先级成功');
            this.getTaskList(true);
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消设置优先级',
          });
        });
    },

    /**
     * 打开文件夹弹窗
     */
    openDirectoryDialog() {
      this.newLinuxName = this.linuxName;
      this.defaultLinuxName = this.linuxName;
      this.pathInput = `${this.homePath}/${this.defaultLinuxName}`;
      this.oldDirPath = `${this.homePath}/${this.defaultLinuxName}`;
      this.getDirectoryList();
    },
    /**
     * 打开文件夹
     */
    openFolder(name) {
      this.pathInput = `${this.pathInput}/${name}`.replace(/\/\//g, '/');
      this.getDirectoryList();
      this.backPageBol = false;
    },

    /**
     * 返回上一页
     */
    backPage() {
      this.pathInput = this.pathInput.substring(0, this.pathInput.lastIndexOf('/'));
      this.oldDirPath = this.pathInput;
      if (this.pathInput === `${this.homePath}/${this.defaultLinuxName}`) {
        this.backPageBol = true;
      }
      this.getDirectoryList();
    },

    /**
     * 返回根目录
     */
    returnRoot() {
      this.pathInput = `${this.homePath}/${this.defaultLinuxName}`;
      this.oldDirPath = `${this.homePath}/${this.defaultLinuxName}`;
      this.backPageBol = true;
      this.getDirectoryList();
    },

    /**
     * 获取弹窗文件列表
     */
    getWorkDirDialogList() {
      this.workDirDialogLoading = true;
      const params = {
        instanceId: this.taskInstanceId,
        dirPath: this.workDirDialogPath,
      };
      postRequest('/api/eda/common/project/getDirectoryList', params)
        .then((res) => {
          this.workDirDialogList = res?.list?.filter(item => item.name.charAt(0) !== '.' && item.is_dir) || [];
          this.workDirDialogLoading = false;
        })
        .catch(() => {
          this.workDirDialogLoading = false;
          // 接口错误后，返回默认路径
          this.workDirDialogList = [];
        });
    },

    /**
     * 弹窗中打开文件夹
     */
    openWorkDirDialogFolder(name) {
      this.workDirDialogPath = `${this.workDirDialogPath}/${name}`.replace(/\/\//g, '/');
      this.getWorkDirDialogList();
    },

    /**
     * 弹窗中返回上一级
     */
    backWorkDirDialogPage() {
      this.workDirDialogPath = this.workDirDialogPath.substring(0, this.workDirDialogPath.lastIndexOf('/'));
      if (this.workDirDialogPath === '') {
        this.workDirDialogPath = '/';
      }
      // 参考pathInput的边界处理，检查是否到达根目录
      if (this.workDirDialogPath === `${this.homePath}/${this.linuxName}`) {
        // 到达根目录时，可以添加相应的逻辑处理
      }
      this.getWorkDirDialogList();
    },

    /**
     * 弹窗中返回根目录
     */
    returnWorkDirDialogRoot() {
      // 参考pathInput的returnRoot方法实现
      this.workDirDialogPath = `${this.homePath}/${this.linuxName}`;
      this.getWorkDirDialogList();
    },

    /**
     * 弹窗中选择目录
     */
    selectWorkDirDialogFolder(name) {
      // 将workDirDialogPath过滤掉fileUploadPath，然后加上当前选择的文件名称
      let filteredPath = this.workDirDialogPath.replace(this.fileUploadPath, '');
      if (filteredPath[0] === '/') {
        filteredPath = filteredPath.substring(1);
      }
      if (filteredPath === '') {
        this.taskForm.workDir = `${name}`;
      } else {
        if (name === '') {
          this.taskForm.workDir = `${filteredPath}`;
        } else {
          this.taskForm.workDir = `${filteredPath}/${name}`;
        }
      }
      this.workDirDialogVisible = false;
      // 查询新目录下的子文件夹
      this.querySubDirectories(name);
    },

    /**
     * 弹窗中创建文件夹
     */
    createWorkDirDialogFolder() {
      this.$prompt('请输入文件夹名称', '创建文件夹', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputErrorMessage: '名称不能为空',
      })
        .then(({ value }) => {
          this.workDirDialogLoading = true;
          postRequest('/api/eda/common/cluster/createClusterFile', {
            instanceId: this.taskInstanceId,
            filePath: `${this.workDirDialogPath}/${value}`,
            fileType: 'dir',
          })
            .then(() => {
              Message.success(`创建${value}文件夹成功`);
              this.getWorkDirDialogList();
            })
            .catch(() => {
              this.workDirDialogLoading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消创建文件夹',
          });
        });
    },

    /**
     * 获取服务器文件列表
     */
    getDirectoryList() {
      this.fileDirectoryLoading = true;
      const params = {
        instanceId: this.taskInstanceId,
        dirPath: this.pathInput,
      };
      postRequest('/api/eda/common/project/getDirectoryList', params)
        .then((res) => {
          this.systemFileList = res?.list?.filter(item => item.name.charAt(0) !== '.') || [];
          this.oldDirPath = this.pathInput;
          this.$refs.serverFileTable.clearSelection();
          this.fileDirectoryLoading = false;
        })
        .catch(() => {
          // 接口错误后，返回默认值path
          this.pathInput = this.oldDirPath;
          this.fileDirectoryLoading = false;
        });
    },

    /**
     * 工作目录 模糊查询
     */
    querySearchDirList(queryString, cb) {
      // 设置搜索状态
      this.isSearchingDirList = true;

      let results = [];

      if (queryString) {
        // 如果用户输入了查询字符串，进行智能匹配
        const currentDir = this.taskForm.workDir || '';

        // 1. 优先匹配当前目录下的子文件夹
        const currentDirResults = this.dirList.filter(item => item.name.toLowerCase().includes(queryString.toLowerCase()) && item.name.startsWith(currentDir));

        // 2. 匹配所有目录（包括上级目录）
        const allResults = this.dirList.filter(item => item.name.toLowerCase().includes(queryString.toLowerCase()));

        // 合并结果，当前目录的优先显示
        results = [
          ...currentDirResults,
          ...allResults.filter(item => !currentDirResults.some(current => current.name === item.name)),
        ];
      } else {
        // 如果没有查询字符串，显示当前目录下的子文件夹
        const currentDir = this.taskForm.workDir || '';
        results = this.dirList.filter(item => item.name.startsWith(currentDir));
      }

      // 调用 callback 返回建议列表的数据
      cb(results);

      // 搜索完成后清除状态（使用setTimeout确保在回调完成后执行）
      setTimeout(() => {
        this.isSearchingDirList = false;
      }, 0);
    },

    /**
     * 任务详情 查询文件夹
     */
    getTaskInfoDirectoryList() {
      const params = {
        instanceId: this.taskInstanceId,
        dirPath: this.pathInput,
      };
      postRequest('/api/eda/common/project/getDirectoryList', params)
        .then((res) => {
          const fileList = res?.list?.filter(item => item.name.charAt(0) !== '.') || [];
          // 如果有真实数据，替换默认数据；如果没有数据，保留默认显示项
          this.systemFileList = fileList.length > 0 ? fileList : [];
          const list = this.systemFileList
            .map(item => ({
              ...item,
              forceUpdate: 0,
              cosPath: this.taskForm.workDir.replace(this.homePath, ''),
              filePath: `${this.pathInput}`,
            }))
            .filter(item => !item.is_dir);

          this.forGetCosFileList(list, 3);
          this.oldDirPath = this.pathInput;
        })
        .catch(() => {
          // 接口错误后，返回默认值path
          this.pathInput = this.oldDirPath;
        });
    },

    /**
     * 轮询查询 是否所有文件都已经同步到cos
     */
    forGetCosFileList(list, scene, maxRetries = 500, currentRetry = 0) {
      let UploadFilesList = [];
      if (currentRetry >= maxRetries) {
        console.log('达到最大重试次数，停止递归');
        return;
      }

      // 检查是否已停止递归
      if (this.stopRecursion) {
        console.log('抽屉已关闭，停止递归');
        return;
      }
      if (currentRetry === 0) {
        UploadFilesList = list.map(item => ({
          cosPath: `${item.cosPath}/${item.name}`,
          filePath: `${item.filePath}/${item.name}`,
          size: item.size,
          name: item.name, // 保留name字段用于后续匹配
        }));
      } else {
        UploadFilesList = list;
      }

      console.log(UploadFilesList, 'UploadFilesList');
      postRequest('/api/eda/common/cluster/describeUploadFiles', { files: UploadFilesList, scene }).then((res) => {
        // 更新systemFileList中的process信息
        res.list.forEach((fileInfo) => {
          // 尝试多种匹配方式：fileName、cosPath、filePath
          const index = this.systemFileList.findIndex((item) => {
            // 优先使用fileName匹配
            if (fileInfo.fileName && item.name === fileInfo.fileName) return true;
            // 使用cosPath匹配（从路径中提取文件名）
            if (fileInfo.cosPath && item.name === fileInfo.cosPath.split('/').pop()) return true;
            // 使用filePath匹配（从路径中提取文件名）
            if (fileInfo.filePath && item.name === fileInfo.filePath.split('/').pop()) return true;
            // 最后尝试name字段
            if (fileInfo.name && item.name === fileInfo.name) return true;
            return false;
          });

          if (index !== -1) {
            this.$set(this.systemFileList, index, {
              ...this.systemFileList[index],
              process: fileInfo.process,
            });
          } else {
            // console.log('未找到匹配的文件，fileInfo:', fileInfo);
          }
        });

        // 检查是否所有文件的process都是100
        const allCompleted = res.list.every(item => item.process === 100);

        if (allCompleted) {
          this.cosFileDownReady = true;
          console.log('所有文件处理完成，停止递归');
          return;
        }

        // 获取process还不是100的文件
        const fileList = res.list.filter(item => item.process !== 100);
        console.log('未完成文件数量:', fileList.length);

        postRequest('/api/eda/common/cluster/syncDistToCos', {
          instanceId: this.taskInstanceId,
          files: fileList,
        }).then((syncDistToCosRes) => {
          console.log(syncDistToCosRes, 'syncDistToCosRes');

          // 递归调用，继续检查未完成的文件
          setTimeout(() => {
            this.forGetCosFileList(fileList, scene, maxRetries, currentRetry + 1);
          }, 3000); // 3秒后再次检查
        });
      });
    },

    /**
     * 多选文件 准备下载
     */
    handleCheckBatchDownLoad(val) {
      const nameList = [];
      val.forEach((item) => {
        nameList.push({
          name: item.name,
        });
      });
      this.batchDownLoadFilesList = nameList;
    },

    /**
     * 文件下载
     */
    downloadFile(files, type) {
      let fileType = '';
      let fileName = '';
      if (files.length !== 0) {
        // 保存notify实例，用于后续单独关闭
        const downloadNotify = this.$notify({
          title: '数据下载',
          message: '正在为您准备文件资源，确保完整无误，请稍候...',
          duration: 0,
        });
        const fileList = JSON.parse(JSON.stringify(files)).map((item) => {
          item.defaultName = item.name;
          if (type === 'detail') {
            item.name = `${this.taskForm.workDir.replace(this.fileUploadPath, '')}/${item.name}`;
          } else {
            item.name = `${this.pathInput}/${item.name}`.replace(this.fileUploadPath, '');
          }
          if (item.name[0] === '/') {
            item.name = item.name.substring(1);
          }
          return cosGetObject(item.name, {});
        });
        if (fileList.length === 1) {
          fileName = files[0].name;
          fileType = getMimeType(fileName);
          Promise.all(fileList).then((res) => {
            // 直接使用原始数据创建Blob，避免通过generateFile中转破坏二进制数据
            const blob = new Blob([res[0].Body], { type: fileType });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(url);
            this.batchDownLoadFilesList = [];
            // 关闭当前下载相关的通知，而不是所有通知
            downloadNotify.close();
          });
        } else {
          fileName = 'file.zip';
          fileType = 'application/octet-stream';
          const zip = new JSZip();
          Promise.all(fileList).then((res) => {
            for (let i = 0; i < this.batchDownLoadFilesList.length; i++) {
              // 直接使用原始数据添加到zip文件，避免通过generateFile中转破坏二进制数据
              zip.file(this.batchDownLoadFilesList[i].name, res[i].Body, { binary: true });
            }
            zip.generateAsync({ type: 'blob' }).then((res) => {
              saveAs(res, fileName);
              // 关闭当前下载相关的通知
              downloadNotify.close();
            });
            this.batchDownLoadFilesList = [];
            this.$refs.taskCosFileList.clearSelection();
          });
        }
      } else {
        this.$message('请选择需要下载的文件');
      }
    },

    /**
     * 终止任务
     */
    cancelClusterTask(taskId) {
      this.$confirm('确定终止任务？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          postRequest('/api/eda/common/cluster/cancelSlurmTask', { taskId }).then(() => {
            this.$message.success(this.$t('computingCluster.taskManagement.cancelSuccess'));
            this.getTaskList(true);
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消终止任务',
          });
        });
    },

    // 确认任务管理
    submitTask() {
      let params = {};
      if (this.taskForm.submissionMethod === 'interactive') {
        const fileList = this.uploadFileList.map(item => item.name) || [];
        this.doneTaskManageLoading = true;
        if (this.submitTaskActiveName === 'taskConfig') {
          params = {
            ...this.taskForm,
            workDir: `${this.fileUploadPath}/${this.taskForm.workDir}`,
            mainFile: this.masterFile[0]?.name || '',
            files: fileList,
          };
          delete params.script;
          delete params.command;
        } else {
          const command = Base64.encode(this.taskForm.script);
          params = {
            workDir: `${this.fileUploadPath}/${this.taskForm.workDir}`,
            command,
            mainFile: this.masterFile[0]?.name || '',
            files: fileList,
          };
        }
      } else {
        this.batchSubmitTask();
        return;
      }

      postRequest('/api/eda/common/cluster/createSlurmTask', params)
        .then(() => {
          this.doneTaskManageLoading = false;
          this.$message.success(this.$t('computingCluster.taskManagement.createSuccess'));
          this.submitTaskVisible = false;
          this.getTaskList(true);
        })
        .catch(() => {
          this.doneTaskManageLoading = false;
        });
    },

    /**
     * 批量提交任务
     * @param type
     */
    batchSubmitTask() {
      this.doneTaskManageLoading = true;
      const batchSubmitTaskFileList = [];
      let params = {};
      postRequest('api/eda/common/project/getDirectoryList', {
        dirPath: `${this.fileUploadPath}/${this.taskForm.workDir}`,
        instanceId: this.taskInstanceId,
      }).then((res) => {
        if (res?.list && res.list.length > 0) {
          res.list.map((item) => {
            if (item.is_dir) {
              postRequest('api/eda/common/project/getDirectoryList', {
                dirPath: `${this.fileUploadPath}/${this.taskForm.workDir}/${item.name}`,
                instanceId: this.taskInstanceId,
              }).then((ress) => {
                if (ress?.list && ress.list.length > 0) {
                  // eslint-disable-next-line max-nested-callbacks
                  const result = ress.list.find(items => items.name === this.taskForm.batchMainFileName);
                  if (result) {
                    batchSubmitTaskFileList.push(`${this.fileUploadPath}/${this.taskForm.workDir}/${item.name}/${result.name}`);

                    params = {
                      ...this.taskForm,
                      name: `${this.taskForm.name}_${item.name}`,
                      workDir: `${this.fileUploadPath}/${this.taskForm.workDir}/${item.name}`,
                      mainFile: result.name,
                    };
                    delete params.script;
                    delete params.command;
                    postRequest('/api/eda/common/cluster/createSlurmTask', params)
                      // eslint-disable-next-line max-nested-callbacks
                      .then(() => {
                        this.doneTaskManageLoading = false;
                        this.$message.success(this.$t('computingCluster.taskManagement.createSuccess'));
                        this.getTaskList(true);
                      })
                      // eslint-disable-next-line max-nested-callbacks
                      .catch(() => {
                        this.doneTaskManageLoading = false;
                      });
                  }
                } else {
                  this.$message.error(`${this.fileUploadPath}/${this.taskForm.workDir}/${item.name}文件夹中不存在${this.taskForm.batchMainFileName}`);
                }
                this.batchSubmitTaskFileList = batchSubmitTaskFileList;
              });
            }
          });
        }
      });
    },

    /**
     * 获取任务列表
     * @param type
     */
    getTaskList(type) {
      this.tableLoading = type;
      const params = {
        filters: [
          {
            name: 'status',
            values: this.filterTaskStatus,
          },
        ],
        offset: this.pageLimit * (this.pageIndex - 1),
        limit: this.pageLimit,
      };
      postRequest('/api/eda/common/cluster/describeSlurmTasks', params)
        .then((res) => {
          this.tableData = res.list || [];
          this.tableDataTotal = res.total || 0;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableDataTotal = 0;
          this.tableLoading = false;
        });
      this.selectedTaskIds = [];
    },

    // 转义 任务状态
    fileTaskStatusList(status) {
      return this.taskStatusList.find(item => item.value === status)?.label;
    },

    /**
     * 展示任务状态图片
     */
    getTaskStatusImage(status) {
      // 定义可用的图片状态映射
      const availableImages = [1, 2, 3, 4, 5, 6, 7]; // 当前存在的图片文件对应的状态

      if (availableImages.includes(status)) {
        try {
          return require(`@/views/computingCluster/components/taskManage/images/${status}taskStatus.svg`);
        } catch (error) {
          console.warn(`图片加载失败: ${status}taskStatus.svg`, error);
          return '';
        }
      }

      // 对于不存在的图片状态，返回空字符串
      return '';
    },

    /**
     * 批量选择服务器文件
     */
    selectionServerFile(selection) {
      this.selectionServerFileList = selection.map(item => `${this.pathInput}/${item.name}`);
    },

    /**
     * 批量选择任务id
     */
    batchSelectionTaskId(selection) {
      this.selectedTaskIds = selection.map(item => item.id);
    },

    /**
     * 批量删除任务
     */
    batchDeleteTask() {
      this.deleteTask(this.selectedTaskIds);
    },

    /**
     * 批量终止任务
     */
    batchStopTask() {
      this.cancelClusterTask(this.selectedTaskIds);
    },

    /**
     * 分页器钩子函数 页数修改时触发
     */
    onCurrentChange(val) {
      this.pageIndex = val;
      this.getTaskList(true);
    },

    /**
     * 每页显示数量钩子函数  每页显示数量修改时触发
     */
    handleSizeChange(pageSize) {
      this.pageLimit = pageSize;
      this.pageIndex = 1;
      this.getTaskList(true);
    },

    /**
     * 切换tab
     */
    handleTabsClick(tab) {
      this.submitTaskActiveName = tab.name;
    },

    /**
     * 禁用table列的checkbox
     */
    selectable(row) {
      if (row.is_dir) {
        return false;
      }
      if (!row.size || row.size < 1024 * 1024 * 1024) {
        return true;
      }
      return false;
    },

    /**
     * 文件大小过滤
     */
    sizeFilter(value, type) {
      const text = '';
      const size = value / 1;
      if (size >= 1024 * 1024 * 1024) {
        if (type === 'downLoad') {
          return `${(size / 1024 / 1024 / 1024).toFixed(2)}G (文件过大，建议使用cosbrower下载)`;
        }
        return `${(size / 1024 / 1024 / 1024).toFixed(2)}G`;
      }
      if (1024 * 1024 < size && size < 1024 * 1024 * 1024) {
        return `${(size / 1024 / 1024).toFixed(2)}M`;
      }
      if (size < 1024 * 1024) {
        return `${(size / 1024).toFixed(2)}KB`;
      }
      return text || '0.00KB';
    },

    /**
     * 拖动开始事件
     */
    handleDragStart(file) {
      // 设置当前拖动的文件
      this.currentDraggedFile = file;
      // 显示拖放目标区域提示
      this.$message({
        message: `正在拖动文件: ${file.name}，请拖放到目标区域`,
        type: 'info',
        duration: 3000,
      });
    },

    /**
     * 点击文件名称上传
     */
    dragUpload(file) {
      this.$message({
        message: `点击了文件: ${file.name}，请使用拖拽功能将文件拖到上传区域`,
        type: 'info',
        duration: 3000,
      });
    },

    /**
     * 处理文件拖放到主文件区域
     */
    handleMasterFileDrop(event) {
      if (this.taskForm.workDir === '') return this.$message.error('请先选择工作目录路径！');
      if (this.currentDraggedFile) {
        event.preventDefault();
        this.cosFileSelect(this.currentDraggedFile, 'master');
        this.currentDraggedFile = null;
      }
    },

    /**
     * 处理文件拖放到普通文件区域
     */
    handleCommonFileDrop(event) {
      if (this.taskForm.workDir === '') return this.$message.error('请先选择工作目录路径！');
      if (this.currentDraggedFile) {
        event.preventDefault();
        this.cosFileSelect(this.currentDraggedFile, 'common');
        this.currentDraggedFile = null;
      }
    },

    /**
     * 处理拖放区域进入
     */
    handleDragOver(event) {
      event.preventDefault();
      event.dataTransfer.dropEffect = 'copy';
    },

    /**
     * 性能监控
     */
    async clickMonitorDialog() {
      try {
        await window.open('/cvmMonitor/d/-ZbSKTbVz1', '_blank');
      } catch (e) {
        this.$message(this.$t('computingCluster.resource.getNodeMonitorDataFailed'), e);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
// table 背景颜色+padding10px
.task_table {
  height: calc(100% - 120px);

  ::v-deep .el-table__body-wrapper {
    height: calc(100% - 48px);
    overflow-y: auto;
  }
}

.pagination {
  padding: 20px 10px;
  background: #fff;
  text-align: right;

  ::v-deep .el-pagination__total {
    float: left;
  }
}

.task-submit_border {
  border-bottom: 1px solid #dcdfe6;
}

// taskConfig-card 独立滚动条
.taskConfig-card {
  height: calc(100vh - 210px);
  overflow-y: auto;
  //margin-bottom: 20px;
}

// fileConfig-card 独立滚动条
.fileConfig-card {
  height: calc(100vh - 300px);
  max-height: calc(100vh - 300px);
}

.taskScriptInput {
  width: calc(100% - 10px);
}

/* 工作目录选择弹窗样式 */
.work-dir-dialog {
  .path-navigation {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding: 8px 0;
    border-bottom: 1px solid #ebeef5;
    gap: 8px;

    .current-path {
      margin-left: 16px;
      font-weight: 500;
      color: #606266;
    }
  }

  .file-list-container {
    margin-bottom: 20px;

    .folder-item {
      display: flex;
      align-items: center;
      cursor: pointer;

      .el-icon-folder-opened {
        margin-right: 8px;
        color: #f6c659;
      }

      .folder-name {
        font-size: 14px;
        color: #606266;
      }
    }

    .folder-item:hover {
      background-color: #f5f7fa;
    }
  }

  .dialog-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 16px;
    border-top: 1px solid #ebeef5;
  }
  ::v-deep .el-textarea__inner {
    //background-color: #f8f9fa !important;
    //font-family: 'Courier New', monospace;
    //font-size: 13px;
    font-family: 'Courier New', monospace;
    font-size: 13px;
    line-height: 1.4;
    background-color: #f8f9fa;
    border: 2px solid #dcdfe6;
  }
}

.el-menu-demo {
  ::v-deep .el-tabs__content {
    padding: 0 !important;
  }
}

.taskDetails {
  font-family: unset;
  line-height: 1.5;
}

.pathInputCls {
  color: #666;
  margin-right: 6px;
}

.dividerVertical {
  height: auto;
}
.upload-demo {
  width: 100%;
  position: relative;

  ::v-deep .el-upload {
    width: 100%;
  }

  ::v-deep .el-upload-dragger {
    width: 100%;
  }
}

.uploadFileList {
  width: 200px;
  top: 0;
  left: 0;
  line-height: 1.5;
  padding: 10px;
  height: 100%;
  overflow-y: auto;
  //pointer-events: none;
}

.uploadFileListNameClass {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.setDividerCls {
  ::v-deep .el-divider__text {
    left: 0px;
    padding-left: 0px;
  }
}

.taskStatusCls {
  width: 16px;
  height: 16px;
}

.workFileBox {
  ::v-deep .el-input-group__append {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
  }
}

.upload-progress {
  color: #409eff;
  font-size: 12px;
  font-weight: 500;
  margin-left: 4px;
}

// 上传进度通知自定义样式
::v-deep .upload-progress-notify,
::v-deep .sync-progress-notify {
  width: 700px !important;

  .el-notification__content {
    margin: 0 !important;

    .el-progress {
      margin-top: 8px;
    }
  }
}
</style>
